import {
  ApolloClient,
  DefaultOptions,
  InMemoryCache,
  createHttpLink,
} from '@apollo/client';

import { Auth } from '@aws-amplify/auth';
import { setContext } from '@apollo/client/link/context';
import { appHost } from './config';

type RequestHeaders = {
  headers: {
    authorization: string;
    [key: string]: string;
  };
};

const defaultOptions: DefaultOptions = {
  watchQuery: {
    fetchPolicy: 'cache-and-network',
    errorPolicy: 'ignore',
  },
  query: {
    fetchPolicy: 'network-only',
    errorPolicy: 'all',
  },
};

const authLink = setContext(
  async (
    _,
    { headers }: { headers: RequestHeaders['headers'] },
  ): Promise<RequestHeaders> => {
    try {
      const session = await Auth.currentSession();
      const token = session.getAccessToken().getJwtToken();

      return {
        headers: {
          ...headers,
          authorization: `Bearer ${token}`,
        },
      };
    } catch (error) {
      // eslint-disable-next-line no-console
      if (error !== 'No current user') console.error(error);

      return { headers };
    }
  },
);

const httpLink = createHttpLink({
  uri: `${appHost}/graphql`,
});

const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
  name: 'jobSeeker',
  version: process.env.VITE_REVISION,
  defaultOptions,
});

export default client;
